<template>
  <div>
    <b-form-group
      id="searchQuery"
      ref="topScrollAnchor"
      label="Filter large list by keywords"
      label-for="query"><b-form-input placeholder="Enter search query here" type="search" id="query" @input="filterChanged" v-model.number="filter"/>
    </b-form-group>
    <pager v-if="matchingCount !== 0" @change="pageChanged" :count="matchingCount" :size="showatonce" :offset="pageNumber * showatonce" />
    <slot name="results" v-bind:items="filtered" v-bind:count="matchingCount"></slot>
    <pager v-if="matchingCount !== 0" @change="pageChanged" :count="matchingCount" :size="showatonce" :offset="pageNumber * showatonce" />
  </div>
</template>

<script>
import Pager from './Pager.vue'

export default {
  components: { Pager },
  props: ['items', 'showatonce'],
  data() {
    return {
      pageNumber: 0,
      filter: '',
      matching: this.items,
      matchingCount: this.items.length,
      filtered: this.items.slice(0, this.showatonce),
    };
  },
  methods: {
    filterChanged(query) {
      this.pageNumber = 0;
      this.searchTerms = query.toLowerCase().split(' ');

      // peform the search
      this.matching = this.items
        // turn to string so different data can be treated the same
        .map(i => JSON.stringify(i))
        // match all keywords entered
        .filter(s => this.searchTerms.length === this.searchTerms.filter(q => s.toLowerCase().indexOf(q) !== -1).length)
        // convert back to an object
        .map(r => JSON.parse(r));

      this.updateFiltered();
    },

    pageChanged(pageNumber) {
      this.pageNumber = pageNumber - 1;
      this.$refs.topScrollAnchor.$el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      this.updateFiltered();
    },

    updateFiltered() {
      this.matchingCount = this.matching.length;
      this.filtered = this.matching.slice(
        this.showatonce * this.pageNumber, 
        this.showatonce * (this.pageNumber + 1));
    },
  }
};
</script>
